import React, { createContext } from "react";

// The old live notifications (socket.io) were switched off on 2026-10-28: nothing had been sent since 2023, messages went to
// every connected browser, and the login token travelled in the connection address. The same names are kept so the
// reader page (pdfViewer/appView.js) keeps working; nothing connects.
export const SocketDataContext = createContext();
export const AppSocket = {
  createConnection: async () => {},
  sendRequest: async () => {},
  logOut: () => {},
};
export const SocketDataProvider = (props) => (
  <SocketDataContext.Provider value={{ AppSocket, userNotification: null }}>{props.children}</SocketDataContext.Provider>
);
